import { stringHash } from '../string';
import { vueBailDepCollector } from "../../../lib/utils";
const breakpointIdStore = 'uicore:expressionBreakpoints';
let expressionErrorVerbose = 0;
let rtNeedDebugger = false; // 启用出错时断点功能，可能会影响JS运行速度
export const syncExpressionErrorVerbose = () => {
  expressionErrorVerbose = +localStorage.getItem('uicore:expressionErrorVerbose') || 0;
  rtNeedDebugger = expressionErrorVerbose >= 2;
};
syncExpressionErrorVerbose();
const errorMarkStyle = 'background: #900; color: #ff9;';
const getErrorLocationForAnonymous = err => {
  if (err && typeof err.stack === 'string') {
    const posMat = /anonymous>?:(\d+):(\d+)/.exec(err.stack);
    if (posMat) {
      const [, line, ch] = posMat;
      return {
        line: +line,
        ch: +ch
      };
    }
  }
  return null;
};
export const detailErrorVerbose = (err, code, info) => {
  const locationMark = info.locationMark || '表达式';
  if (info.stage === 'compiling') {
    const errLog = [`[UICore] ${locationMark}编译失败`, err, {
      code
    }];
    console.error(...errLog);
    return errLog;
  }
  // 切掉所有 at xxx的调用栈
  const errorInfo = `${err}`.split('\n').filter(item => !item.trimStart().startsWith('at'))[0];
  const evalPath = info === null || info === void 0 ? void 0 : info.evalPath;
  const msgs = [`%c[UICore]%c ${locationMark}执行失败。`, errorMarkStyle, '', {
    code
  }, '\n', errorInfo, evalPath && '\n', evalPath, '\n执行上下文:', info === null || info === void 0 ? void 0 : info.ctxs];
  const errLoc = getErrorLocationForAnonymous(err);
  if (errLoc) {
    msgs[0] += `位置：${errLoc.line}:${errLoc.ch}。`;
  }
  if (rtNeedDebugger && info.codeHash) {
    msgs[0] += `如果要调试，请运行 %cucToggleBreakpoint("${info.codeHash}")\n`;
    msgs.splice(3, 0, 'font-family: monospace; color: #630;');
    if (!window.ucToggleBreakpoint) {
      window.ucIsExprBreakpointEnabled = (codeHash, err) => {
        const val = window.sessionStorage.getItem(breakpointIdStore);
        // eslint-disable-next-line @typescript-eslint/prefer-optional-chain
        if (!val || !val.includes(`|${codeHash}|`)) return false;
        const errLoc = getErrorLocationForAnonymous(err);
        if (errLoc) {
          console.error(`%c 行 ${errLoc.line}，列 ${errLoc.ch} %c`, errorMarkStyle, 'color: #900', err.message);
        }
        return true;
      };
      window.ucToggleBreakpoint = codeHash => {
        let val = window.sessionStorage.getItem(breakpointIdStore) || '|';
        const k = `|${codeHash}|`;
        const idx = val.indexOf(k);
        if (idx === -1) val += k;else val = val.slice(0, idx) + val.slice(idx + k.length);
        window.sessionStorage.setItem(breakpointIdStore, val);
        if (idx === -1) {
          console.log('[UICore] 错误断点已开启，请再次触发表达式，或者刷新页面.... %c（再次执行此命令，将关闭断点）', 'color: #999');
        } else {
          console.log('[UICore] 错误断点已关闭.... %c（再次执行此命令，将重启断点）', 'color: #999');
        }
      };
    }
  }
  console.error(...msgs);
  return msgs;
};
let expressionErrorWarned = false;
const defaultWarnExprError = expressionErrorVerbose ? detailErrorVerbose : () => {
  if (expressionErrorWarned) return;
  expressionErrorWarned = true;
  console.log('%c[UICore]%c 代码存在错误。若要查看，请执行并刷新页面 localStorage.setItem("uicore:expressionErrorVerbose", "1");', errorMarkStyle, 'color: red; background-color: #ff9');
};
if (typeof window.ucWarnExpressionError !== 'function') {
  window.ucWarnExpressionError = defaultWarnExprError;
}
export const getCompiledCatchErrorLogger = (errorIdentifier, code, locationMark = '', ctxs = []) => {
  const codeHash = stringHash(code).toString(36);
  return `// 如果出错就输出错误提示

  let _fC,_wR=typeof window!='undefined',_fU=n=>{if(_fC=_wR&&window[n],typeof _fC!='function')_fC=null;return _fC};
  if (_fU('ucWarnExpressionError')) {
  const ctxs=[${ctxs.join(',')}];
  let _fD="";
  try{const _fA=ctxs.find(_fB=>_fB.ucEvalPath);_fA && (_fD=_fA.ucEvalPath);}catch(e){}
  _fC(${errorIdentifier}, ${JSON.stringify(code)}, { stage: 'executing', codeHash: "${codeHash}",ctxs,evalPath:_fD,locationMark: ${JSON.stringify(locationMark)} });}
  ${rtNeedDebugger ? `if (_fU('ucIsExprBreakpointEnabled') && _fC("${codeHash}", ${errorIdentifier})) debugger;` : ''}
`;
};
/** try Eval的报错里会使用ucEvalPath这个特殊的字段来取得对执行路径的描述 */
export function getUcEvalPath(cb) {
  if (expressionErrorVerbose < 1) return;
  return {
    get ucEvalPath() {
      try {
        return vueBailDepCollector(cb);
      } catch (e) {}
    }
  };
}